'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbWerkgeverselectieController.$inject = ['$log', '$q', '$timeout', 'WebApiService', 'WerkgeverselectieService'];



var _module = _angular2.default.module('cb.Werkgeverselectie', []);

_module.directive('cbWerkgeverselectie', cbWerkgeverselectie);

exports.default = _module;

/**
 * @ngdoc directive
 * @name cbWerkgeverselectie
 * @restrict AE
 *
 * @description
 * Input group to find and select registered employers to activate benefits. Use the directive with these options:
 *
 * displayed: input for max. items before refinement warning.
 * employer: output for the selected employer.
 * employerid: input to retrieve an employer based on employer ID.
 * outline: input to set style from input element.
 *
 * @example
 * HTML Usage:
 * <cb-werkgeverselectie employer="vm.werkgever" outline="true"></cb-werkgeverselectie>
 *
 */

function cbWerkgeverselectie() {
    return {
        restrict: 'AE',
        transclude: true,
        bindToController: {
            displayed: '=?',
            employer: '=?',
            employerid: '=?',
            outline: '=?'
        },
        scope: true,
        controller: cbWerkgeverselectieController,
        controllerAs: 'cbWerkgeverSelectie',
        template: "﻿<div class=\"input-group\" ng-if=\"!cbWerkgeverSelectie.employer\">\r\n    <!-- Search for employer -->\r\n    <div class=\"input-text\" ng-class=\"{ 'input-text--outline': cbWerkgeverSelectie.outline }\">\r\n        <input class=\"input-text__input input\"\r\n               type=\"text\"\r\n               id=\"werkgeverselectie-input\"\r\n               qa-id=\"werkgeverselectie-searchinput\"\r\n               name=\"searchinput\"\r\n               autocomplete=\"off\"\r\n               tabindex=\"1\"\r\n               ng-model=\"cbWerkgeverSelectie.searchInput\"\r\n               ng-keyup=\"cbWerkgeverSelectie.searchEmployer()\">\r\n        <label class=\"input-text__label label\">Werkgever</label>\r\n        <span class=\"input-text__icon input-text__icon--clear\" qa-id=\"werkgeverselectie-searchinput-clear\" ng-show=\"cbWerkgeverSelectie.showResult\" ng-click=\"cbWerkgeverSelectie.removeEmployer()\"></span>\r\n    </div>\r\n    <div class=\"input-group__messages\" ng-if=\"!cbWerkgeverSelectie.showResult\">\r\n        <div class=\"input-message\">Bij Centraal Beheer heeft 80% van werkend Nederland recht op collectiviteitskorting. Vul hierboven uw werkgever in. En bekijk of u ook korting krijgt.</div>\r\n    </div>\r\n\r\n    <!-- Search results -->\r\n    <div class=\"input-lookup\" ng-if=\"cbWerkgeverSelectie.showResult\" qa-id=\"werkgeverselectie-results\">\r\n\r\n        <!-- Wrong input / no employer found -->\r\n        <div class=\"input-lookup__header\" ng-if=\"!cbWerkgeverSelectie.isFound\" qa-id=\"werkgeverselectie-search-error\">\r\n            <span>Geen werkgevers gevonden.</span>\r\n        </div>\r\n\r\n        <!-- Searching for employers -->\r\n        <div class=\"input-lookup__header\" ng-if=\"cbWerkgeverSelectie.isLoading\" qa-id=\"werkgeverselectie-searching\">\r\n            <span class=\"input-lookup__spinner spinner spinner--sm\"></span>Aan het zoeken...\r\n        </div>\r\n\r\n        <!-- Refine results -->\r\n        <div class=\"input-lookup__header\" ng-if=\"cbWerkgeverSelectie.wdata.gevonden > cbWerkgeverSelectie.displayed\" qa-id=\"werkgeverselectie-max-results\">\r\n            Er zijn meer dan {{cbWerkgeverSelectie.displayed}} resultaten. Verfijn uw zoekopdracht.\r\n        </div>\r\n\r\n        <!--List employers-->\r\n        <ul class=\"input-lookup__list\" ng-if=\"!cbWerkgeverSelectie.isLoading && cbWerkgeverSelectie.isFound\" qa-id=\"werkgeverselectie-employers\">\r\n            <li ng-repeat=\"werkgever in cbWerkgeverSelectie.wdata.werkgevers | orderBy: 'Werkgevernaam' track by $index\"\r\n                class=\"input-lookup__list-item\">\r\n                <a class=\"input-lookup__link\"\r\n                   qa-id=\"werkgeverselectie-employers-item-{{$index}}\"\r\n                   href=\"\"\r\n                   ng-click=\"cbWerkgeverSelectie.selectEmployer(werkgever)\">\r\n                    {{werkgever.Werkgevernaam}} ({{werkgever.Plaats}})</a>\r\n            </li>\r\n        </ul>\r\n\r\n        <!-- Number of results -->\r\n        <div class=\"input-lookup__footer\" ng-if=\"!cbWerkgeverSelectie.isLoading && cbWerkgeverSelectie.isFound\" qa-id=\"werkgeverselectie-number-of-results\">\r\n            {{cbWerkgeverSelectie.wdata.gevonden}} resultaten van totaal {{cbWerkgeverSelectie.wdata.totaal}} werkgevers.\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<!-- Employer selected -->\r\n<div class=\"input-group\" ng-if=\"cbWerkgeverSelectie.employer\" qa-id=\"werkgeverselectie-employer-selected\">\r\n    <div class=\"input-text\">\r\n        <div class=\"input-text__input input is-valid\"></div>\r\n        <label class=\"input-text__label label\">Werkgever</label>\r\n    </div>\r\n    <div class=\"input-lookup\">\r\n        <div class=\"input-lookup__header\">\r\n\r\n            <!-- Employer information -->\r\n            <div>\r\n                <b>{{cbWerkgeverSelectie.employer.Werkgevernaam}}</b> {{cbWerkgeverSelectie.employer.Plaats}}\r\n                <br/>\r\n                Collectiviteitsnummer: {{cbWerkgeverSelectie.employer.WerkgeverId}}\r\n                <br />\r\n            </div>\r\n\r\n            <!-- Remove selected employer -->\r\n            <div ng-click=\"cbWerkgeverSelectie.removeEmployer()\" qa-id=\"werkgeverselectie-change-employer-link\">\r\n                <a href=\"\">Selecteer opnieuw</a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"
    };
}

function cbWerkgeverselectieController($log, $q, $timeout, WebApiService, WerkgeverselectieService) {
    var vm = this;

    var deferred = void 0;
    var oldInput = void 0; //var to save search input
    var timeout = void 0; //var for timeout

    activate();

    function activate() {
        vm.searchInput = '';
        vm.displayed = vm.displayed || 20;

        vm.getEmployer = getEmployer;
        vm.searchEmployer = searchEmployer;
        vm.selectEmployer = selectEmployer;
        vm.removeEmployer = removeEmployer;

        //Get selected employer from cookie data
        getEmployer();
    }

    //Delete selected employer
    function removeEmployer() {
        vm.employer = null;
        vm.searchInput = null;
        vm.showResult = false;

        WerkgeverselectieService.clearCookie();

        $timeout(function () {
            _angular2.default.element('#werkgeverselectie-input').focus();
        });
    }

    //Get (previously) selected employer from directive or cookie
    function getEmployer() {
        deferred = $q.defer();
        var werkgeverid = void 0;

        if (vm.employerid) {
            werkgeverid = vm.employerid;
        } else {
            werkgeverid = WerkgeverselectieService.getCookieValue();
        }

        if (werkgeverid) {
            WerkgeverselectieService.getEmployer(werkgeverid).then(function (response) {
                if (response.Werkgever) {
                    selectEmployer(response.Werkgever);
                } else {
                    $log.warn('Werkgevercontrol returned an error');
                    deferred.reject({});
                }
            }, function (error) {
                $log.warn('Werkgevercontrol returned an error');
                deferred.reject({});
            });
        } else {
            deferred.resolve({});
        }
        return deferred.promise;
    }

    //Search employer based on user input
    function searchEmployer() {
        if (!vm.searchInput || vm.searchInput.length < 2) {
            return;
        }

        vm.showResult = true;
        $timeout(function () {
            if (oldInput === vm.searchInput) {
                return;
            }
            $timeout.cancel(timeout);

            timeout = $timeout(function () {
                oldInput = vm.searchInput;
                vm.isLoading = true;

                var requestData = {
                    ZoekenWerkgevers: {
                        zoekItem: vm.searchInput,
                        maxAantalResultaten: 99
                    }
                };

                var result = WebApiService.get(requestData, 'ZoekenWerkgeversControl');
                result.then(function (data) {
                    vm.wdata = {};

                    if (data.Resultaat && data.Resultaat.AantalGevonden === 0) {
                        vm.isFound = false;
                        vm.isLoading = false;
                        return;
                    } else {
                        vm.isFound = true;
                    }

                    vm.wdata.werkgevers = data.Werkgever;
                    vm.wdata.totaal = data.Resultaat.AantalRetour;
                    vm.wdata.gevonden = data.Resultaat.AantalGevonden;
                    vm.isLoading = false;
                }, function () {
                    vm.isLoading = false;
                    $log.log('error');
                });
            }, 200);
        }, 1);
    }

    //Select employer from dropdown list
    function selectEmployer(werkgever) {
        vm.employer = werkgever;
        vm.showResult = false;
        WerkgeverselectieService.setCookieValue(werkgever.WerkgeverId);

        deferred.resolve({});
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/forms/werkgeverselectie/cb-werkgeverselectie.directive.js
// module id = 800
// module chunks = 0